/**
 * @license
 * Copyright (c) 2016 - 2026 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { html, LitElement } from 'lit';
import { defineCustomElement } from '@vaadin/component-base/src/define.js';
import { LumoInjectionMixin } from '@vaadin/vaadin-themable-mixin/lumo-injection-mixin.js';
import { ThemableMixin } from '@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js';
import { uploadIconStyles } from './styles/vaadin-upload-icon-base-styles.js';

/**
 * An element used internally by `<vaadin-upload>`. Not intended to be used separately.
 *
 * @customElement vaadin-upload-icon
 * @extends HTMLElement
 * @private
 */
class UploadIcon extends ThemableMixin(LumoInjectionMixin(LitElement)) {
  static get is() {
    return 'vaadin-upload-icon';
  }

  static get styles() {
    return uploadIconStyles;
  }

  static get lumoInjector() {
    return { ...super.lumoInjector, includeBaseStyles: true };
  }

  /** @protected */
  render() {
    return html``;
  }
}

defineCustomElement(UploadIcon);

export { UploadIcon };
